(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/set-self-exclusion.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/set-self-exclusion.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _jotai = jotai,
  useAtom = _jotai.useAtom;
const _svs$selfExclusion$co = svs.selfExclusion.components,
  Games = _svs$selfExclusion$co.Games,
  Periods = _svs$selfExclusion$co.Periods,
  NativeApp = _svs$selfExclusion$co.NativeApp;
const Button = svs.ui.ReactButton;
const Form = svs.ui.reactForm.Form;
const _React = React,
  useState = _React.useState;
const _svs$selfExclusion$Co = svs.selfExclusion.Constants,
  DOCS = _svs$selfExclusion$Co.DOCS,
  isNativeApp = _svs$selfExclusion$Co.isNativeApp;
const DataService = svs.accountservices.player_exclusions.DataService;
const _svs$selfExclusion$st = svs.selfExclusion.store.selfExclusionAtoms,
  activeExclusionsAtom = _svs$selfExclusion$st.activeExclusionsAtom,
  isNaExcludedAtom = _svs$selfExclusion$st.isNaExcludedAtom;
const SetSelfExclusion = () => {
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    game = _useState2[0],
    setGame = _useState2[1];
  const _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    period = _useState4[0],
    setPeriod = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSubmitted = _useState6[0],
    setIsSubmitted = _useState6[1];
  const _useAtom = useAtom(activeExclusionsAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    activeExclusions = _useAtom2[0],
    setActiveExclusions = _useAtom2[1];
  const _useAtom3 = useAtom(isNaExcludedAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    setNaExcluded = _useAtom4[1];
  const exclusionDates = svs.selfExclusion.useExpiryDate(activeExclusions, game);
  const setExclusion = eidType => {
    DataService.setSelfExclusion(game, period, setActiveExclusions, setNaExcluded, eidType);
    setIsSubmitted(false);
    setGame();
    setPeriod();
  };
  const handleSubmit = e => {
    e.preventDefault();
    setIsSubmitted(true);
    if (!game || !period) {
      return;
    }
    svs.selfExclusion.showEidDialog(setExclusion);
  };
  const handleGame = gameValue => {
    setGame(gameValue);
    setPeriod();
    setIsSubmitted(false);
  };
  const handlePeriod = periodValue => {
    setPeriod(periodValue);
    setIsSubmitted(false);
  };
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2",
    id: "set-self-exclusions"
  }, React.createElement(Form, {
    "aria-live": "polite",
    onSubmit: handleSubmit
  }, React.createElement("h2", {
    className: "align-center f-700 f-bold"
  }, "Spelpaus i 3 m\xE5nader - 3 \xE5r"), React.createElement(Games, {
    game: game,
    isSubmitted: isSubmitted,
    onHandleGame: handleGame
  }), React.createElement(Periods, {
    exclusionDates: exclusionDates,
    exclusions: activeExclusions,
    isSubmitted: isSubmitted,
    onHandlePeriod: handlePeriod,
    period: period
  }), React.createElement("p", null, "Genom att aktivera en l\xE4ngre spelpaus godk\xE4nner du", ' ', isNativeApp ? React.createElement(NativeApp, null) : React.createElement("a", {
    className: "fc-sport-75",
    href: DOCS.PERSONAL_INFORMATION,
    rel: "noreferrer",
    target: "_blank"
  }, "villkoren f\xF6r spelpaus"), ' ', "och bekr\xE4ftar att du tagit del av", ' ', React.createElement("a", {
    className: "fc-sport-75",
    href: DOCS.PERSONAL_POLICY,
    rel: "noreferrer",
    target: "_blank"
  }, "information om behandling av personuppgifter."), ' '), React.createElement(Button, {
    block: true,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Pausa"))), React.createElement("hr", {
    "aria-hidden": true,
    className: "exclusion-border-bottom"
  }));
};
svs.selfExclusion.components.SetSelfExclusion = SetSelfExclusion;

 })(window);